// english
import common from './module/common';
import login from './module/login';
import findPassword from './module/findPassword';
import home from './module/home';
import device from './module/device';
import issue from './module/issue';
import site from './module/site';
import customer from './module/customer';
import logs from './module/logs';
import blacklist from './module/blacklist';
import configModel from './module/configModel';
import deviceModel from './module/deviceModel';
import menuInterface from './module/menuInterface';
import role from './module/role';
import user from './module/user';
import my from './module/my';
import systemDashboard from './module/systemDashboard';
import application from './module/application';
import attach from './module/attach';
import message from './module/message';
import docs from './module/docs';
import attachment from './module/attachment';

export default {
  // 通用
  ...common,

  // 登录
  ...login,

  // 找回密码
  ...findPassword,

  // 首页
  ...home,

  // 站点
  ...site,

  // 设备
  ...device,

  // 问题
  ...issue,

  // 客户
  ...customer,

  // 日志
  ...logs,

  // 黑名单
  ...blacklist,

  // config data model
  ...configModel,

  // device model
  ...deviceModel,

  // menu and interface
  ...menuInterface,

  // role
  ...role,

  // user
  ...user,

  // my
  ...my,

  // systemDashboard
  ...systemDashboard,

  // 应用接入
  ...application,

  // 消息中心
  ...message,

  // 附件
  ...attach,
  // docs
  ...docs,

  // attachment
  ...attachment,
};
